<div class="control-section">
    <div class="e-rte-custom-control">
        <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 4px;">
            <label *ngIf="label" style="margin: 0; font-weight: 500;font-size: 12px; font-style: normal;">Descrição</label>
            <ejs-tooltip 
                #cidEditorTooltip
                [content]="'<strong>Adicionar Doenças (CID):</strong><br>• Digite <strong>@</strong> seguido do código ou nome da doença para buscar CIDs<br>• Exemplo: <strong>@A01</strong>, <strong>@gripe</strong> ou <strong>@diabetes</strong><br>• Selecione o CID desejado usando o mouse, <strong>Tab</strong> ou <strong>Enter</strong><br>• Os CIDs adicionados aparecerão destacados em azul no texto<br><br><strong>Comportamento:</strong><br>• CIDs inseridos via <strong>@</strong> são adicionados automaticamente em <strong>Doenças Ativas</strong><br>• Se o CID estava em Doenças Inativas, ele será <strong>reativado</strong><br>• Ao remover um CID inserido via <strong>@</strong> do texto:<br>&nbsp;&nbsp;- Se foi a primeira inserção: será <strong>removido completamente</strong><br>&nbsp;&nbsp;- Se já existia no histórico: vai para <strong>Doenças Inativas</strong><br><br><strong>Importante:</strong><br>• Apenas CIDs inseridos via <strong>@</strong> são gerenciados automaticamente<br>• CIDs já existentes em textos carregados não são removidos automaticamente<br><br><strong>Carregar Modelos:</strong><br>• Clique no ícone 📋 (arquivo médico) na toolbar para importar modelos pré-definidos de história clínica'"
                [position]="'BottomCenter'"
                [openDelay]="100"
                [cssClass]="'cid-tooltip-custom'"
                [windowCollision]="true">
                <i class="fas fa-question-circle" 
                   style="color: #085ca0; font-size: 16px; cursor: help;"></i>
            </ejs-tooltip>
        </div>
        
        <ejs-richtexteditor 
            #rteObj
            id="rteObj"
            [(value)]="value"
            [toolbarSettings]="tools"
            [placeholder]="'Descrição (digite @ para adicionar CIDs ativos)'"
            [height]="height"
            (change)="change($event)"
            (toolbarClick)="toolbarClick($event)">
        </ejs-richtexteditor>
        
        <ejs-mention
            #mentionObj
            [mentionChar]="mentionChar"
            [dataSource]="mentionData"
            [fields]="fields"
            [target]="target"
            [popupWidth]="popupWidth"
            [popupHeight]="popupHeight"
            [showMentionChar]="false"
            (change)="onMentionChange($event)">
            <ng-template #displayTemplate let-data>
                <span class="cid-mention" contenteditable="false" style="background-color: #e3f2fd; color: #1976d2; padding: 2px 6px; border-radius: 3px; font-weight: 500; display: inline; margin: 0 2px;">
                    <span class="cid-codigo">{{data.codigo}}</span> - 
                    <span class="cid-descricao">{{data.descricao}}</span>
                </span>
            </ng-template>
            <ng-template #noRecordsTemplate>
                <div class="no-records" style="padding: 8px; color: #757575; font-style: italic;">
                    Nenhum CID encontrado.
                </div>
            </ng-template>
        </ejs-mention>
    </div>
</div>

<!-- Modal de pesquisa de história clínica -->
<app-historia-modelo-pesquisa 
    #historiaPesquisa
    (registroSelecionado)="modeloSelecionado($event)">
</app-historia-modelo-pesquisa>
